import { Switch } from '@components/ui/Primitives'
import React from 'react'
import styled from 'styled-components'

interface Props {
  id: string
  label: React.ReactNode
  aside?: React.ReactNode
  hint?: React.ReactNode
  checked: boolean
  onChange: (checked: boolean) => void
}

export const SettingsSwitchField: React.FC<Props> = ({
  id,
  label,
  aside,
  hint,
  checked,
  onChange
}) => (
  <Row>
    <SwitchRow>
      <LabelGroup>
        <label htmlFor={id}>
          <SwitchLabel>{label}</SwitchLabel>
        </label>
        {aside}
      </LabelGroup>
      <Switch
        id={id}
        height={24}
        checked={checked}
        onChange={e => onChange(e.currentTarget.checked)}
      />
    </SwitchRow>
    {hint ? <Hint>{hint}</Hint> : null}
  </Row>
)

const Row = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.spacing.sm}rem;
  gap: ${({ theme }) => theme.spacing.xxxs}rem;
`

const SwitchRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.md}rem;
`

const LabelGroup = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs}rem;
  min-width: 0;
  flex-wrap: wrap;
`

const SwitchLabel = styled.span`
  color: ${({ theme }) => theme.colors.neutralBlack};
  font-weight: 500;
`

const Hint = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSize.sm}rem;
  color: ${({ theme }) => theme.colors.metalGray};
`
